import { useState, type ReactNode } from 'react';

import { createAppStore, type AppStore } from './appStore';
import { AppStoreContext } from './AppStoreContext';

interface AppStoreProviderProps {
  readonly children: ReactNode;
  readonly store?: AppStore;
}

export function AppStoreProvider({ children, store }: AppStoreProviderProps) {
  const [appStore] = useState(() => store ?? createAppStore());

  return <AppStoreContext.Provider value={appStore}>{children}</AppStoreContext.Provider>;
}
